
import { Logger }          from '@/util/logger';

export enum FrameType {

  OBJECT,
  ARRAY,
  UNKNOWN
};

/**
 *
 * @class Frame
 *
 * @brief a single stack frame; we use a stack based tree builder for
 * building out the object tree of the JSON we are parsing.
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      May 2023
 *
 */
export class Frame {

  /** the kind of frame (node in tree) */
  public kind: FrameType = FrameType.UNKNOWN;

  /** start position (absolute) in the raw accumulated string */
  public start: number   = 0;

  /** end position (absolute) in the raw accumulated string */
  public end: number     = 0;

  /** the key watchers can use to track the object of this frame */
  public key: string     = '';

  /* for array blocks, we track the element position */
  public index: number   = 0;

  /* for object blocks, we track the field we are on */
  public field: string   = '';

  /** standard constructor */
  public constructor(init?: Partial<Frame>) {

    Object.assign(this, init);
  }

  /** fetch the current element index (arrays) */
  public currentIndex(): number {

    return this.index;
  }

  /** fetch the current field name (objects) */
  public currentField(): string {
    return this.field;
  }

  /** is the frame for an object? */
  public isObject(): boolean {

    return this.kind == FrameType.OBJECT;
  }

  /** is the frame for an array? */
  public isArray(): boolean {

    return this.kind == FrameType.ARRAY;
  }

}
